import { CircleCheck } from 'lucide-react';
import { useEffect, useRef } from 'react';
import { Button } from '@/components/ui/button';

export function FormSuccessState({ titleId, title, description, actionLabel, onAction, children }) {
  const titleRef = useRef(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <div className="flex flex-col items-center py-8 text-center sm:py-12">
      <span className="flex size-16 items-center justify-center rounded-full bg-pad">
        <CircleCheck aria-hidden="true" strokeWidth={2.25} className="size-9 text-graphite" />
      </span>
      <h2
        ref={titleRef}
        id={titleId}
        tabIndex={-1}
        className="mt-6 text-2xl font-extrabold tracking-tight text-graphite focus:outline-none sm:text-3xl"
      >
        {title}
      </h2>
      <p className="mt-3 max-w-md text-lg leading-relaxed text-steel">{description}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        {actionLabel ? (
          <Button variant="outline" onClick={onAction}>
            {actionLabel}
          </Button>
        ) : null}
        {children}
      </div>
    </div>
  );
}